<template>
  <div class="new_report_container">
    <van-field v-model="content" rows="10" autosize type="textarea" placeholder="请输入文字内容" />
    <div class="tips">最多可输入10000字</div>
    <div class="new_report_pictures">
      <van-uploader type="file" accept="image/*" :upload-icon="uploadImgIcon" v-model="picList" multiple :max-count="picMaxCount" :after-read="afterImgsRead" :before-delete="deleteImgs"></van-uploader>
    </div>
    <div class="new_report_video">
      <van-uploader class="video_upload" type="file" accept="video/*" :upload-icon="uploadVideoIcon" v-model="videoList" :max-count="videoMaxCount" :after-read="afterVideoRead" :before-delete="deleteVideo" @click-preview="previewVideoHandler">
        <template #preview-cover="{ }">
          <div class="preview-cover van-ellipsis">
            <van-icon name="play-circle-o" />
          </div>
        </template>
      </van-uploader>
    </div>
    <div class="new_report_category">
      <div class="report_category_title">报料分类</div>
      <div class="report_category_list">
        <ul class="clearfix">
          <li v-for="(item,i) in categoryList" :key="i" :class="{category_item:true,category_item_on:item.id==curCategoryId}" @click="curCategoryId=item.id">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <div class="location">
      <Icon iconClass="locate" /><span v-text="LocationCity" v-if="LocationCity=='获取定位'" @click="getLocation"></span><span v-text="LocationCity" v-else></span>
    </div>
    <div class="operate_btns">
      <van-button round type="danger" size="small" @click="cancel">取消</van-button>
      <van-button round type="info" size="small" @click="submit">提交</van-button>
    </div>
    <!-- 视频预览 -->
    <div class="video_preview_dialog" v-if="showVideo">
      <div class="video_preview_box">
        <video controls controlslist="nodownload" disablepictureinpicture :src="videoSrc"></video>
      </div>
      <i role="button" class="van-icon van-icon-cross van-popup__close-icon van-popup__close-icon--top-right" @click="closeVideo"></i>
    </div>
  </div>
</template>
<script>
import { loadBMap } from "@/utils";
import { mapState } from "vuex";
import reportApi from "@/api/apis/report.js";
import UploadServer from "@/api/apis/upload.js";
export default {
  name: "BaoliaoNew",
  computed: {
    ...mapState("app", ["userInfo", "nodeCode", "appName"]),
  },
  data() {
    return {
      categoryParams: {
        pageNo: 0,
        pageSize: 10,
      },
      categoryList: [],
      curCategoryId: null,
      content: "",
      picList: [], // 图片列表
      videoList: [], // 视频列表
      picMaxCount: 9,
      videoMaxCount: 1,
      latitude: "",
      longitude: "",
      LocationCity: "获取定位",
      uploadImgIcon: require('@/assets/images/upload_img_bg.png'),
      uploadVideoIcon: require('@/assets/images/upload_video_bg.png'),
      showVideo: false, // 是否显示视频预览
      videoSrc: "", // 视频播放地址
    };
  },
  methods: {
    /* 获取报料频道 */
    getReportChannelByCategory() {
      var _this = this;

      reportApi
        .listDiscloseChannelByCategoryCode(_this.categoryParams)
        .then((res) => {
          if (res.suc == 1) {
            _this.categoryList = res.data.list;
            if (_this.categoryList.length > 0) {
              _this.curCategoryId = _this.categoryList[0].id;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 上传图片 */
    uploadPic(file) {
      var _this = this;
      UploadServer.fetchUploadPic(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传图片 自行将文件上传至服务器 */
    afterImgsRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadPic(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadPic(file);
      }
    },
    /* 移除图片 */
    deleteImgs(file) {
      var _this = this;

      return (file, name) => {
        let fileIndex = name.index;
        _this.picList[file].splice(fileIndex, 1);
      };
    },
    /* 上传视频 */
    uploadVideo(file) {
      var _this = this;
      UploadServer.fetchUploadVideo(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传视频 自行将文件上传至服务器 */
    afterVideoRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadVideo(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadVideo(file);
      }
    },
    /* 移除视频 */
    deleteVideo(file) {
      var _this = this;

      return (file, name) => {
        let fileIndex = name.index;
        _this.videoList[file].splice(fileIndex, 1);
      };
    },
    /* 视频预览 */
    previewVideoHandler(file) {
      var _this = this;
      if (!!file.status && file.status == "uploading") {
        return
      } else {
        _this.showVideo = true;
        _this.videoSrc = file.url;
      }
    },
    /* 关闭视频预览 */
    closeVideo() {
      var _this = this;
      _this.showVideo = false;
      _this.videoSrc = "";
    },
    /* 获取定位 */
    getLocation() {
      var _this = this;
      _this.BMap = window.BMap;
      var geolocation = new _this.BMap.Geolocation();
      geolocation.getCurrentPosition(function (position) {
        if (this.getStatus() == 0) {//成功获取位置信息
          let city = position.address.city; //获取城市信息
          let district = position.address.district; //获取区
          let street = position.address.street; //获取街道
          _this.latitude = position.latitude;
          _this.longitude = position.longitude;
          _this.LocationCity = city + district + street;
        } else {
          _this.LocationCity = "无法获取到位置信息";
        }
      }, function () {
        _this.LocationCity = "定位失败";
      }, { provider: "baidu", enableHighAccuracy: true });
    },
    /* 取消 */
    cancel() {
      this.$router.go(-1);
    },
    /* 提交报料 */
    submit() {
      var _this = this;

      if (!_this.userInfo) {
        _this.$router.push("/login");
        return;
      }

      try {
        let arr = [];
        _this.picList.forEach((item) => {
          if (item.status == "uploading") {
            throw new Error();
          }
          arr.push(item.id);
        });

        _this.videoList.forEach((item) => {
          if (item.status == "uploading") {
            throw new Error();
          }
        });

        let data = {
          channelId: _this.curCategoryId,
          title: "",
          description: _this.content,
          address: (_this.LocationCity == "获取定位" || _this.LocationCity == "定位失败") ? '' : _this.LocationCity,
          longitude: _this.longitude,
          latitude: _this.latitude,
          contactPhone: "",
          source: 2, //非必填，报料来源，0:未知；1：PC报料；2：H5；3：android手机；4：IPhone手机
          streamId: _this.videoList.length > 0 ? _this.videoList[0].id : null,
          pictureIdList: arr,
        };

        data = JSON.stringify(data);

        reportApi
          .addDiscloseMaterial(_this.userInfo.id, _this.nodeCode, data)
          .then((res) => {
            if (res.suc == 1) {
              /* _this.$toast({
                message: "提交成功！",
                position: "center",
              });
              setTimeout(() => {
                _this.$router.go(-1);
              }, 1500); */
              _this.$dialog
                .alert({
                  message: "提交成功！",
                })
                .then(() => {
                  _this.$router.go(-1);
                });
            } else {
              _this.$toast({
                message: res.message || res.text,
                position: "center",
              });
            }
          })
          .catch((err) => {
            _this.$toast({
              message: "接口调用出错",
              position: "center",
            });
          });
      } catch (e) {
        _this.$toast({
          message: "您有文件还未上传完！",
          position: "center",
        });
      }
    },
  },
  created() {
    document.title = this.appName + "报料平台";
    if (!!this.userInfo) {
      this.getReportChannelByCategory();
    } else {
      this.$router.push("/login");
    }
    UploadServer.startUpload();
  },
  mounted() {
    // 调用脚本加载百度地图api
    loadBMap();
  },
  destroyed() {
    UploadServer.stopUpload();
  }
};
</script>
<style lang="scss" scoped>
.new_report_container {
  width: 100%;
  height: 100%;
  padding: 15px 15px 67px;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  .van-cell {
    padding: 0;
    &::after {
      display: none;
    }
  }
  .tips {
    line-height: 24px;
    text-align: right;
    font-size: 14px;
  }
  .new_report_pictures {
    border-top: 1px solid #ececec;
    padding-top: 15px;
    padding-bottom: 5px;
    /deep/.van-icon__image {
      width: 100%;
      height: 100%;
    }
  }
  .new_report_video {
    border-top: 1px solid #ececec;
    padding-top: 15px;
    padding-bottom: 5px;
    /deep/.van-icon__image {
      width: 100%;
      height: 100%;
    }
    .video_upload {
      /deep/.van-icon-description {
        display: none;
      }
      /deep/.van-uploader__file-name {
        display: none;
      }
      .preview-cover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        .van-icon {
          position: absolute;
          left: 25px;
          top: 25px;
          font-size: 30px;
          color: #fff;
        }
      }
    }
  }
  .new_report_category {
    border-top: 1px solid #ececec;
    padding-top: 15px;
    padding-bottom: 5px;
    .report_category_title {
      font-size: 16;
      font-weight: bold;
    }
    .report_category_list {
      .category_item {
        float: left;
        line-height: 30px;
        padding: 0 10px;
        margin: 10px 10px 10px 0;
        font-size: 14px;
        border: 1px solid #ececec;
        border-radius: 15px;
        &.category_item_on {
          background-color: #d70c2a;
          border-color: #d70c2a;
          color: #fff;
        }
      }
    }
  }
  .location {
    padding-top: 15px;
    padding-bottom: 5px;
    line-height: 24px;
    .tj-svg-icon {
      color: #a6a6a6;
      margin-right: 5px;
      font-size: 14px;
    }
    span {
      color: #666;
      font-size: 14px;
    }
  }
  .operate_btns {
    width: 100%;
    position: fixed;
    background-color: #fff;
    padding: 10px 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    .van-button {
      width: 25%;
    }
  }
}
.video_preview_dialog {
  position: fixed;
  top: 12.4vw;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 12.4vw);
  padding-top: 12.4vw;
  background-color: rgba(0, 0, 0, 0.9);
  .video_preview_box {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    overflow: hidden;
    video {
      display: block;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>